import { SmButton, SmLoading } from '@smiles/smiles-react-design-system';
import React, { useCallback, useEffect, useState } from 'react';

import useApi from '@/hooks/useApi';
import { useLD } from '@/hooks/useLD';

import { getRules } from '@/services/requests/Rules';
import { TOptinContent } from '@/services/requests/Liferay/types';
import useEvent from '@/hooks/useEvent';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';

type TProps = {
  data: TOptinContent;
  onBack: () => void;
  onRedirect: (value: 'error') => void;
};

export function ScreenTerms({ data, onBack, onRedirect }: TProps) {
  const [loading, setLoading] = useState(true);
  const [terms, setTerms] = useState('');

  const { portalID } = useLD();

  const { ApiRules, ApiInteractions } = useApi();

  const event = useEvent();

  const fetchData = useCallback(async () => {
    const result = await getRules(
      ApiRules,
      portalID,
      data.terms.terms_content_id,
    );
    if (result === 'error') {
      onRedirect('error');
    } else {
      setTerms(result);
      setLoading(false);
    }
  }, [ApiRules, data.terms.terms_content_id, onRedirect, portalID]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleBack = () => {
    dispatchInteraction(ApiInteractions, 'extra_optin_click_back_rules', {
      recommendationId: event.data.recommendationId,
    });

    onBack();
  };

  if (loading) {
    return (
      <div className="smls-optin__loading">
        <SmLoading loadingSize="small" />
      </div>
    );
  }

  return (
    <div className="smls-optin__modal-content">
      <div className="smls-optin__button--back">
        <SmButton
          onClick={handleBack}
          isPill
          isOutlined
          icon={<span className="material-icons">arrow_back_ios</span>}
        />
      </div>
      <div
        className="smls-optin__modal-body"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: terms }}
      />
    </div>
  );
}
